var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_49",
    "data-name": "Komponente 10 \\u2013 49",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analysis"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35498",
    "data-name": "Gruppe 35498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35497",
    "data-name": "Gruppe 35497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46786",
    "data-name": "Pfad 46786",
    d: "M57.668,10.639,47.359.332a1.133,1.133,0,0,0-.8-.332H12.914a3.4,3.4,0,0,0-3.4,3.4v2.16A14.988,14.988,0,0,0,0,19.495a1.133,1.133,0,0,0,1.133,1.133H14.963A1.133,1.133,0,0,0,16.1,19.495V5.664a1.133,1.133,0,0,0-1.133-1.133,14.957,14.957,0,0,0-3.182.342V3.4a1.134,1.134,0,0,1,1.133-1.133H45.426v6.91a3.4,3.4,0,0,0,3.4,3.4h6.91V54.6A1.134,1.134,0,0,1,54.6,55.734H12.914A1.134,1.134,0,0,1,11.781,54.6V44.9a1.133,1.133,0,0,0-2.266,0v9.7a3.4,3.4,0,0,0,3.4,3.4H54.6A3.4,3.4,0,0,0,58,54.6V11.44A1.133,1.133,0,0,0,57.668,10.639ZM13.831,6.847V18.362H2.316A12.719,12.719,0,0,1,13.831,6.847Zm34.994,3.462a1.134,1.134,0,0,1-1.133-1.133V3.867l6.442,6.441Z",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35500",
    "data-name": "Gruppe 35500",
    transform: "translate(9.516 39.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35499",
    "data-name": "Gruppe 35499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46787",
    "data-name": "Pfad 46787",
    d: "M85.934,350.332a1.132,1.132,0,1,0,.332.8A1.14,1.14,0,0,0,85.934,350.332Z",
    transform: "translate(-84 -350)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35502",
    "data-name": "Gruppe 35502",
    transform: "translate(4.058 8.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35501",
    "data-name": "Gruppe 35501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46788",
    "data-name": "Pfad 46788",
    d: "M50.782,75.819a1.133,1.133,0,0,0-1.133,1.133v12.7h-12.7a1.133,1.133,0,0,0-1.133,1.133A14.963,14.963,0,1,0,50.782,75.819Zm1.133,2.316a12.641,12.641,0,0,1,7,2.908l-7,7ZM50.782,103.48A12.715,12.715,0,0,1,38.135,91.915H50.782a1.129,1.129,0,0,0,.8-.331h0l8.939-8.939a12.691,12.691,0,0,1-9.74,20.836Z",
    transform: "translate(-35.819 -75.819)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35504",
    "data-name": "Gruppe 35504",
    transform: "translate(17.435 35.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35503",
    "data-name": "Gruppe 35503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46789",
    "data-name": "Pfad 46789",
    d: "M186.1,315.605a3.4,3.4,0,0,0-3.13,4.723l-6.526,6.526a3.392,3.392,0,0,0-2.935-.015l-4.334-4.334a3.4,3.4,0,1,0-6.25.186l-4.157,4.157a3.4,3.4,0,1,0,1.6,1.6l4.134-4.134a3.387,3.387,0,0,0,3.183-.092l4.212,4.212a3.4,3.4,0,1,0,6.135.033L184.5,322a3.4,3.4,0,1,0,1.6-6.4ZM157.3,331.049a1.133,1.133,0,1,1,.784-1.949l.013.014.017.015a1.131,1.131,0,0,1-.814,1.919Zm8.7-8.647a1.133,1.133,0,1,1,1.133-1.133A1.134,1.134,0,0,1,166.006,322.4Zm8.95,8.642a1.133,1.133,0,1,1,1.133-1.133A1.134,1.134,0,0,1,174.956,331.044Zm11.14-10.908A1.133,1.133,0,1,1,187.228,319,1.134,1.134,0,0,1,186.1,320.136Z",
    transform: "translate(-153.905 -315.605)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35506",
    "data-name": "Gruppe 35506",
    transform: "translate(36.852 26.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35505",
    "data-name": "Gruppe 35505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46790",
    "data-name": "Pfad 46790",
    d: "M332.423,235h-5.979a1.133,1.133,0,1,0,0,2.266h5.979a1.133,1.133,0,1,0,0-2.266Z",
    transform: "translate(-325.311 -235)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35508",
    "data-name": "Gruppe 35508",
    transform: "translate(47.988 26.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35507",
    "data-name": "Gruppe 35507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46791",
    "data-name": "Pfad 46791",
    d: "M425.554,235.332a1.132,1.132,0,1,0,.332.8A1.141,1.141,0,0,0,425.554,235.332Z",
    transform: "translate(-423.62 -235)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35510",
    "data-name": "Gruppe 35510",
    transform: "translate(36.852 15.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35509",
    "data-name": "Gruppe 35509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46792",
    "data-name": "Pfad 46792",
    d: "M340.282,139H326.444a1.133,1.133,0,0,0,0,2.266h13.838a1.133,1.133,0,0,0,0-2.266Z",
    transform: "translate(-325.311 -139)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35512",
    "data-name": "Gruppe 35512",
    transform: "translate(36.852 21.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35511",
    "data-name": "Gruppe 35511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46793",
    "data-name": "Pfad 46793",
    d: "M340.282,187H326.444a1.133,1.133,0,1,0,0,2.266h13.838a1.133,1.133,0,1,0,0-2.266Z",
    transform: "translate(-325.311 -187)",
    fill: "#a5b5af"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.99dacffe61bd63b5cf1ff363e7b6bd3f.svg";
export { ForwardRef as ReactComponent };